import {Injectable} from '@angular/core';
import {ApiDataService} from '@ox/data';
import {WarrantyPayload} from '@ox/typings';
import {map, take, catchError, throwError} from 'rxjs';
import {OX_KEYS,apiUrlMap} from '@ox/config';

@Injectable()
export class WarrantiesService {

  constructor(private apiData: ApiDataService) {
  }

  public searchForWarranties(vin: string, vehicleOdemeter: string) {
    const route = apiUrlMap.warranties.get(vin);

    return this.apiData.get<WarrantyPayload[]>(route, undefined, true).pipe(
      take(1),
      map(
        (response) => {
          const arr = response.data;
          const reducer: { expired: WarrantyPayload[], active: WarrantyPayload[] } = {expired: [], active: []};

          const {expired, active} = arr.reduce(
            (accumulator, current) => {
              const isActive = current?.[OX_KEYS.TAB_DETAIL_ITEM.STATUS] == OX_KEYS.TAB_DETAIL_ITEM.ACTIVE;
              const isExpired = current?.[OX_KEYS.TAB_DETAIL_ITEM.STATUS] == OX_KEYS.TAB_DETAIL_ITEM.EXPIRED;
              const endDate = new Date(current?.[OX_KEYS.TAB_DETAIL_ITEM.END_DATE]);
              //depending on the format of the date look at https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date#return_value
              //could have a possible issue in the future if the date string is returned differently could break logic
              const currentDate = new Date();
              const isInDateRange = currentDate < endDate;
              const isInMileageRange = Number(vehicleOdemeter) < Number(current?.[OX_KEYS.TAB_DETAIL_ITEM.END_MILEAGE]);

              if (isActive && isInDateRange && isInMileageRange) {
                accumulator.active.push(current);
              } else if (isExpired) {
                accumulator.expired.push(current);
              } else if (isInDateRange && isInMileageRange) {
                accumulator.active.push(current);
              } else {
                accumulator.expired.push(current);
              }

              return accumulator;
            },
            reducer);
          return {expired, active};
        }
      ),
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}
